import { render, staticRenderFns } from "./Incident.vue?vue&type=template&id=f46ab9d6&scoped=true"
import script from "./Incident.vue?vue&type=script&lang=js"
export * from "./Incident.vue?vue&type=script&lang=js"
import style0 from "./Incident.vue?vue&type=style&index=0&id=f46ab9d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46ab9d6",
  null
  
)

export default component.exports